import { jsx as _jsx } from "react/jsx-runtime";
const SettingSidebar = ({ tabs, activeTab, onTabChange }) => {
    return (_jsx("div", { className: "flex flex-col gap-0.5 py-1.5 w-[200px] shrink-0 bg-gray-100 border-r border-gray-300 overflow-y-auto", children: tabs.map((tab) => (_jsx("button", { onClick: () => onTabChange(tab.id), className: `
            relative flex items-center px-3 py-3 text-left 
            text-[13px] transition-all duration-150 
            border-l-[3px] border-transparent
            font-sans font-bold leading-[150%]
            cursor-pointer
            ${activeTab === tab.id
                ? 'text-primary-purple-70 bg-transparent border-l-primary-purple-70'
                : 'text-gray-600 bg-gray-100 hover:border-l-gray-500'}
          `, type: "button", children: tab.label }, tab.id))) }));
};
export default SettingSidebar;
